import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import React from "react";

import styles from "./StartStep.module.css"
import {Col} from "react-bootstrap";


const StartStep = props => {
    return (
        <Container className={styles.startstep}>
            <Row>
                <Col md={3}></Col>
                <Col md={6}>
                    <div>
                        {props.children}
                    </div>
                </Col>
                <Col md={3}></Col>
            </Row>
        </Container>
    );
};

export default StartStep;